import React from "react";
import { useLocation } from "react-router-dom";
import Header from "../Header/Header";
import Footer from "../Footer/footer";

import Contact from "./Contact";

const ContactUS = () => {
  const location = useLocation();
  return (
    <div className={`fd-main-wrapper ${location.pathname !== "/" ? "page-padding" : ""}`}>

      <Header />

      <Contact />

      <Footer />

    </div>
  );
};

export default ContactUS;